import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { translate } from '@jsverse/transloco';
import { RouterSegments } from 'src/app/models/router-segments';

@Component({
  selector: 'app-activity-details',
  templateUrl: './activity-details.component.html',
  styleUrl: './activity-details.component.scss',
  standalone: false
})
export class ActivityDetailsComponent {

  jobId: string;
  RouterSegments = RouterSegments;
  tenantId: string;
  id: string;

  get scheduleId(): string {
    return this.data?.scheduleId || '-';
  }

  get scheduleName(): string {
    return this.data?.scheduleName || '-';
  }

  get scheduleStatus(): string {
    return this.data?.scheduleStatus || '-';
  }

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,private sidenavService: SidenavService,
  public matdialogRef: MatDialogRef<ActivityDetailsComponent>, private dialog: MatDialog, private router: Router, private authService: AuthService) {
  }

   ngOnInit(): void {
    if (this.data) {
      this.jobId = this.data.jobId;
      this.tenantId = this.data.tenantId;
      this.id = this.data?.scheduleId;
    }
  }

   navigateToInstance() {
    this.router.navigate(['', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.SCHEDULE, this.id]);
    this.matdialogRef.close();
  }
}
